import { Navigate } from 'react-router-dom';
import { checkEncryptedLocalStorageItem } from './localStorage';

export const PrivateRoute = ({ element }) => {
    const isLogin = checkEncryptedLocalStorageItem();
    if (isLogin) {
        return element;
    } else {
        return <Navigate to="/login" />;
    }
}

export const PrivateLoginRoute = ({ element }) => {
    const isLogin = checkEncryptedLocalStorageItem();
    if (!isLogin) {
        return element;
    } else {
        return <Navigate to="/" />;
    }
}